import PaymentsCard from 'routes/PaymentAnalytics/PaymentsCard/PaymentsCard';

export default PaymentsCard;
